export default function CTA() {
  return (
    <section className="relative w-full py-24 md:py-32 px-4 md:px-8 lg:px-14 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20moody%20dark%20toned%20flatlay%20of%20assorted%20fashion%20items%20including%20a%20warm%20toned%20hoodie%20sneakers%20and%20a%20cap%20arranged%20on%20a%20deep%20charcoal%20surface%2C%20dramatic%20overhead%20spotlight%20creating%20strong%20highlights%20and%20rich%20shadows%2C%20editorial%20product%20photography%20with%20luxurious%20dark%20atmosphere%20and%20warm%20amber%20accent%20lighting&width=1600&height=800&seq=cta-bg-v02&orientation=landscape"
          alt="CSSBuy Spreadsheet links atualizados"
          title="Links Atualizados CSSBuy Spreadsheet"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/55 to-black/70"></div>
      </div>

      <div className="relative max-w-[800px] mx-auto text-center">
        <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight tracking-wide mb-5">
          LINKS ATUALIZADOS DIARIAMENTE
        </h2>
        <p className="text-sm md:text-base text-white/80 leading-relaxed mb-3 max-w-lg mx-auto">
          Mais de 10.000 usuários já utilizam o CSSBuy Spreadsheet.
        </p>
        <p className="text-sm md:text-base text-white/80 leading-relaxed mb-10 max-w-lg mx-auto">
          Produtos verificados. Compre com segurança.
        </p>

        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-3 px-8 py-4 bg-foreground-950 text-background-50 rounded-full text-sm font-bold uppercase tracking-wider hover:bg-foreground-800 transition-colors cursor-pointer whitespace-nowrap"
        >
          <span className="flex items-center justify-center w-8 h-8 rounded-full bg-primary-500">
            <i className="ri-shopping-bag-line text-background-50 text-sm"></i>
          </span>
          ABRIR SPREADSHEET
          <i className="ri-arrow-right-up-line text-primary-500"></i>
        </a>
      </div>
    </section>
  );
}